<template>
  <div class="d-flex justify-content-center">
      <b-icon icon="three-dots" animation="cylon" variant="primary" font-scale="3">
      </b-icon>
  </div>
</template>

<script>
export default {
  props: ['options'],

  data: () => ({
    observer: null,
  }),

  mounted() {
    const options = this.options || {};
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
      }
    }, options);

    this.observer.observe(this.$el);
  },

  destroyed() {
    this.observer.disconnect();
  },
};
</script>
